export const initialValues = {
  first_name: "",
  last_name: "",
  email: "",
  mobile_number: "",
  password: "",
  confirm_password: "",
  role_id: "",
  image: "",
  is_active: 0,
  country_code: "",
};
